import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../library/assets/Facebook_Logo_Secondary.png'
import _imports_1 from '../library/assets/Fill-3.png'


const _withScopeId = n => (_pushScopeId("data-v-5863104a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "social-banner" }
const _hoisted_2 = { class: "asahi-social-banner-container" }
const _hoisted_3 = { class: "p-1" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"p-1\" data-v-5863104a><a href=\"https://www.kp.pl\" target=\"_blank\" data-v-5863104a><img src=\"" + _imports_1 + "\" data-v-5863104a></a></div><div class=\"p-1 d-flex\" data-v-5863104a><a href=\"https://www.abcalkoholu.pl/\" target=\"_blank\" class=\"ps-2 ps-md-0 site-footer-link\" data-v-5863104a> abc.alkoholu.pl </a></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Follow Us')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: _ctx.getLinkByName('fb').url,
          target: "_blank",
          title: "Facebook"
        }, _hoisted_6, 8, _hoisted_4)
      ]),
      _hoisted_7
    ])
  ]))
}